import { FailureKind } from '@/hooks/api/assets/useGetRecentFailures';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';

export const useCanRemediate = (kind: FailureKind) => {
  const { permissions } = useGetCurrentUser();
  const permittedByKind: Record<FailureKind, boolean> = {
    asset: permissions.canReprocessAssets,
    report: !permissions.canOnlySearch,
    'part-finder-report': permissions.canEditPartFinderReport,
  };
  return permittedByKind[kind];
};
